import moment from 'moment';
import type { FullBoatDetail } from 'src/types/boat/BoatDetail';
import type { Immutable } from 'src/types/ImmutableMap';

export const noop = () => undefined;

export const plural = (quantity: number) => (quantity !== 1 ? 's' : '');

const formatters = {
  guests: (n: number) => `${n} ${n > 1 ? 'people' : 'person'}`,
  adults: (n: number) => `${n} Adult${n > 1 ? 's' : ''}`,
  seniors: (n: number) => `${n} Senior${n > 1 ? 's' : ''}`,
  children: (n: number) => `${n} Child${n > 1 ? 'ren' : ''}`,
  infants: (n: number) => `${n} Infant${n > 1 ? 's' : ''}`,
} as const;
export const formatGroupSize = (number: number, type: keyof typeof formatters) => (
  formatters[type](number)
);

type ImmutablePrice = Immutable<{
  minimum_unit?: string;
  unit?: string;
}>;

export const getMinimumUnit = (price: ImmutablePrice) => price.get('minimum_unit', price.get('unit'));

export const getBoatHeadline = (boat: FullBoatDetail): string => {
  /**
   * Handle the case where the boat is not yet loaded.
   */
  if (!boat || Object.keys(boat).length === 0) return '';

  return boat.shortname || boat.headline;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const dateFormat = (dateString: string | undefined, _name?: string) => moment(dateString);

export const defined = (val: unknown) => typeof val !== 'undefined';
